export default {
  'result-success.success.title': 'Submission Success',
  'result-success.success.description':
    'The submission results page is used to feed back the results of a series of operational tasks. If it is a simple operation, use the Message global prompt feedback. This text area can show a simple supplementary explanation. If there is a similar requirement for displaying “documents”, the following gray area can present more complicated content.',
  'result-success.success.operate-title': 'Project Name',
  'result-success.success.operate-id': 'Project ID：',
  'result-success.success.principal': 'Principal：',
  'result-success.success.operate-time': 'Effective time：',
  'result-success.success.step1-title': 'Create project',
  'result-success.success.step1-operator': 'Qu Lili',
  'result-success.success.step2-title': 'Departmental preliminary review',
  'result-success.success.step2-operator': 'Zhou Maomao',
  'result-success.success.step2-extra': 'Urge',
  'result-success.success.step3-title': 'Financial review',
  'result-success.success.step4-title': 'Finish',
  'result-success.success.btn-return': 'Back to list',
  'result-success.success.btn-project': 'View project',
  'result-success.success.btn-print': 'Print',
};
